import { bootstrapPlugin } from "./src/plugins/bootstrap/index.mjs";
import { breadcrumbPlugin } from "./src/plugins/breadcrumb/index.mjs";
import { createBootstrap } from "./src/plugins/createBootstrap/index.mjs";
import { modalControllerPlugin } from "./src/plugins/modalController/index.mjs";
import { modalManagerPlugin } from "./src/plugins/modalManager/index.mjs";
import { popoverPlugin } from "./src/plugins/popoverController/index.mjs";
import { rtlPlugin } from "./src/plugins/rtl/index.mjs";
import { toastPlugin } from "./src/plugins/toastController/index.mjs";
const index = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  bootstrapPlugin,
  breadcrumbPlugin,
  createBootstrap,
  modalControllerPlugin,
  modalManagerPlugin,
  popoverPlugin,
  rtlPlugin,
  toastPlugin
}, Symbol.toStringTag, { value: "Module" }));
export {
  index as i
};
//# sourceMappingURL=index-DwDHvBIQ.mjs.map
